/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import { StepperComponent } from '../../../../_metronic/assets/ts/components'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { getClimaPlantOne, getplantsOne } from '../../../services/plantsService'
import { GraphicsModalPlant } from '../ GraphicsModalPlant'
import { LoadingSpan } from '../Loadings/loadingSpan'
import { Loading } from '../Loadings/loading'
import './styles.css'
import { getReportsAll } from '../../../services/reports'
import { TableReportModalPlant } from '../TableReportModalPlant'
import { getUnitConsumerAllFilter } from '../../../services/unitConsumerService'
import { TableUnitConsumerModalPlant } from '../TableUnitConsumerModalPlant'
import { NotImported } from '../NotInformat'
import { TableDevicesModalPlant } from '../TableDevicesModalPlant'
import { ItemAlarm } from './components/itemAlarm'
import { ModalUpdatePlant } from './components/ModalUpdatePlant'
import { ModalUpdatePrognosisPlant } from './components/ModalUpdatePrognosisPlant'
import { useAuth } from '../../../modules/auth'
import { formatDateInverter, formatDateTimeBarra } from '../../../utils/date'
import { DetailsPlants } from './components/DetailsPlants'
import { CommentsPlant } from './components/CommentsPlant'
import { TagsPlant } from './components/TagsPlant'
import { ArchivesPlant } from './components/ArchivesPlant'
import { getReportsGenerationAll } from '../../../services/reportsGenerationService'
import { TableReportGenerationModalPlant } from '../TableReportGenerationModalPlant'
import useSize from '../../../hooks/useSize'
import { SelectGlobal } from '../SelectGlobal'
import { FaHandshake } from '../icons';
import { SelectPlantPortal } from './components/SelectPlantPortal/selectPlantPortal.module'
import { useQuery } from 'react-query'


type Props = {
    show: boolean;
    handleClose: () => void;
    plant: string
    modalRef?: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalPlantComposite = ({show, handleClose, plant, modalRef}: Props) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [data, setData] = useState<any>(null)
  const [metaData, setMetaData] = useState<any>(null)
  const [plantSelected, setPlantSelected] = useState<string>(plant);
  const [loading, setLoading] = useState<boolean>(true)
  const [loadingCharts] = useState<boolean>(false)
  //const [chartsSum, setChartsSum] = useState(null);
 
  const [filter] = useState<string>("GERADO");
  const [filterTypeRepots, setFilterTypeReports] = useState<string>("DETALHADO");
  const [reports, setReports] = useState<any[]>([])
  const [reportsGeneration, setReportsGeneration] = useState<any[]>([])
  const [unitConsumers, setUnitConsumers] = useState<any[]>([])
  const [loadingReports, setLoadingReports] = useState<boolean>(true)
  const [loadingUnitConsumers, setLoadingConsumers] = useState<boolean>(true)
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false)
  const [showUpdatePrognosisModal, setShowUpdatePrognosisModal] = useState<boolean>(false)
  const user = useAuth();
  const {width: largura} = useSize();



  const [clima, setClima] = useState<any[]>()

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const getPlants = async () => {
    try {
      if(plantSelected && plantSelected !== ""){
        setLoading(true)
        
        const myPlant = await getplantsOne(plantSelected)
        setData(myPlant)
        if(myPlant && myPlant.type_plant === "COMPOSTA"){
          setMetaData(myPlant)
        }
      }
    } catch (error) {
      console.log(error)
    }finally{
      setLoading(false)
    }
  }


// const { 
//   data: queryResult, 
//   isLoading: loading, 
//   refetch: refresh 
// } = useQuery(
//   ["getPlantOneComposite", plantSelected],
//   async () => {
//     if (!plantSelected) return null;

//     const currentPlant = await getplantsOne(plantSelected);

//     let compositePlant = null;

//     if (currentPlant?.type_plant === "COMPOSTA") {
//       compositePlant = currentPlant;
//     }

//     else if (currentPlant?.parent_id) {
//       compositePlant = await getplantsOne(currentPlant.parent_id);
//     }

//     return {
//       current: currentPlant,
//       composite: compositePlant 
//     };
//   },
//   {
//     onError: (error) => {
//       console.log(error);
//     },
//     keepPreviousData: true, 
//   }
// );

// const data: any = queryResult?.current ?? null;
// const metaData: any = queryResult?.composite ?? null;

  const getUnitConsumers = async () => {
    try {
      if(plant){
        setLoadingConsumers(true)
        const myPlant = await getUnitConsumerAllFilter(null, plantSelected)
        setUnitConsumers(myPlant)
      }
    } catch (error) {
      console.log(error)
    }finally{
      setLoadingConsumers(false)
    }
  }

  const getClimaPlant = async () => {
    try {
      if(plantSelected && plantSelected !== ""){
        const myClima = await getClimaPlantOne(plantSelected) 
        setClima(myClima)
      }
    } catch (error) {
      console.log(error)
    }finally{
    }
  }

  const getReports = async () => {
    try {
      setLoadingReports(true)

      if(plantSelected && plantSelected !== ""){
        const reports = await getReportsAll(filter, undefined, plantSelected)
        setReports(reports)
      }

    } catch (error) {
      console.log(error)
      //toggleToast("Erro ao buscar relatórios. ", "error")
    }finally{
      setLoadingReports(false)
    }
  }

  const getReportsGeneration = async () => {
    try {
      setLoadingReports(true)

      if(plantSelected && plantSelected !== ""){
        const reportsGeneration = await getReportsGenerationAll(filter, undefined, plantSelected)
        setReportsGeneration(reportsGeneration)
      }

    } catch (error) {
      console.log(error)
      //toggleToast("Erro ao buscar relatórios. ", "error")
    }finally{
      setLoadingReports(false)
    }
  }

  const refresh = () => {
    getPlants()
  }
  
  useEffect(() => {
   getPlants()
   getClimaPlant()
   //getChartsBD()
   getReports()
   getReportsGeneration()
   getUnitConsumers()
  }, [plantSelected]);


  useEffect(() => {
    setPlantSelected(plant)
  }, [plant])
  
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName={
        largura < 1200 ? 'modal-dialog modal-dialog-centered modal-fullscreen-xxl-down p-5 h-auto' 
        : 'modal-dialog modal-dialog-centered modal-xl'
      }
      show={show}
      //style={{width: '1700px !important'}}
      onHide={handleClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div ref={modalRef}>
          <div className='modal-header' style={{display: 'flex', flexDirection: largura < 1200 ? 'column' : 'row'}}>
            <div style={{display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap', justifyContent: largura < 1200 ? 'space-between' : ""}}>
              <h2>Detalhes da usina{" "}</h2>
              
              {largura < 1200 && 
                <div style={{display: 'flex', gap: '0.2rem', width: largura < 1200 ? '30%' : '', justifyContent: 'end'}}>
                  {user.currentUser?.role.slug !== "CLIENTE" && data && !data.isIncludedComposite &&(
                    <div
                      className='btn btn-sm btn-icon btn-active-color-primary border border-right border-right-2 border-bottom-0 border-top-0 border-left-0 text-muted text-hover-primary'
                      style={{display: 'flex', gap: '0.5rem', width: 'auto', paddingRight: '0.5rem'}}
                      onClick={()=> {
                        setShowUpdateModal(true)
                      }}
                    >
                      <KTSVG className='svg-icon-1' path='/media/icons/duotune/coding/cod001.svg' />
                    </div>
                  )}

                  {user.currentUser?.role.slug !== "CLIENTE" && data && data.isIncludedComposite &&(
                    <div
                      className='btn btn-sm btn-icon btn-active-color-primary border border-right border-right-2 border-bottom-0 border-top-0 border-left-0 text-muted text-hover-primary'
                      style={{display: 'flex', gap: '0.5rem', width: 'auto', paddingRight: '0.5rem'}}
                      data-bs-toggle='tooltip'
                      title='Prognóstico da usina'
                      onClick={()=> {
                        setShowUpdatePrognosisModal(true)
                      }}
                    >
                      <KTSVG className='svg-icon-1' path='/media/icons/duotune/graphs/gra007.svg' />
                    </div>
                  )}

                  <div className='btn btn-sm btn-icon btn-active-color-primary' 
                    onClick={()=> {
                      handleClose()
                      setData({})
                      setMetaData(null)
                      //setChartsSum(null)
                    }}
                  >
                    <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                  </div>
                </div>
              }
              
              <div>
                {loading ? 
                  <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                  :
                    metaData ? 
                      (
                        <SelectPlantPortal
                          itens={[metaData, ... metaData.childPlants]}
                          buttonAll={false}
                          textSearch={"Buscar usina COMPOSTA"}
                          textButtonInit={"Selecione a usina COMPOSTA"}
                          labelKey='plantName'
                          valueKey='id'
                          typeIcon='img'
                          //linkIcon='https://res.cloudinary.com/deq3ehxe3/image/upload/v1735238752/plant2_tuwshh.png'
                          //imageSize='25px'
                          
                          //typeIcon='img'
                          refresh={refresh}
                          value={plantSelected}
                          style={{flex: '7', width: 'auto',  minWidth: largura > 1200 ? '35rem' : '', maxWidth: '40rem' }}
                          //className={"w-100"}
                          onChange={(value: string) => {
                            setPlantSelected(value);
                              //setFilterCollaborator ? setFilterCollaborator(value) : console.log('Sem função de filtro')
                          }}
                        />
                      )
                 : ""}
              </div>
            </div>
            
            {/* {largura > 1200 && (<h2 style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>Detalhes da usina  {data ? 
              (
                <select
                  className='form-select form-select-solid'
                  data-kt-select2='true'
                  data-placeholder='Select option'
                  data-allow-clear='true'
                  //defaultValue={formik.values.tipo ? formik.values.tipo : ''}
                  //onChange={formik.handleChange("tipo")}
                >
                  <option value={''}></option>
                  <option value={'SERVICO'}>Serviço</option>
                  <option value={'PRODUTO'}>Produto</option>
                </select>
              )
            
            : loading ? <LoadingSpan style={{marginLeft: '0.5rem'}}/> : ""}</h2>)} */}
            
            {largura >= 1200 && 
            <div style={{display: 'flex', gap: '0.2rem', width: largura < 1200 ? '100%' : '', justifyContent: 'end'}}>
              {user.currentUser?.role.slug !== "CLIENTE" && data && !data.isIncludedComposite &&(
                <div 
                  className='btn btn-sm btn-icon btn-active-color-primary border border-right border-right-2 border-bottom-0 border-top-0 border-left-0 text-muted text-hover-primary' 
                  style={{display: 'flex', gap: '0.5rem', width: 'auto', paddingRight: '0.5rem'}}
                  onClick={()=> {
                    setShowUpdateModal(true)
                  }}
                >
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='mt-1 fw-semibold fs-5'>CONFIGURAÇÕES DA USINA</span>
                  </h3>
                  <KTSVG className='svg-icon-1' path='/media/icons/duotune/coding/cod001.svg' />
                </div>
              )}

              {user.currentUser?.role.slug !== "CLIENTE" && data && data.isIncludedComposite &&(
                <div
                  className='btn btn-sm btn-icon btn-active-color-primary border border-right border-right-2 border-bottom-0 border-top-0 border-left-0 text-muted text-hover-primary'
                  style={{display: 'flex', gap: '0.5rem', width: 'auto', paddingRight: '0.5rem'}}
                  onClick={()=> {
                    setShowUpdatePrognosisModal(true)
                  }}
                >
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='mt-1 fw-semibold fs-5'>PROGNÓSTICO DA USINA</span>
                  </h3>
                  <KTSVG className='svg-icon-1' path='/media/icons/duotune/graphs/gra007.svg' />
                </div>
              )}

              <div className='btn btn-sm btn-icon btn-active-color-primary' 
                onClick={()=> {
                  handleClose()
                  setData({})
                  setMetaData(null)
                  //setChartsSum(null)
                }}
              >
                <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
              </div>
            </div>}

            {/* {largura < 1200 && (<h2>Detalhes da usina  {
              data ? (
                <select
                  className='form-select form-select-solid'
                  data-kt-select2='true'
                  data-placeholder='Select option'
                  data-allow-clear='true'
                  //defaultValue={formik.values.tipo ? formik.values.tipo : ''}
                  //onChange={formik.handleChange("tipo")}
                >
                  <option value={''}></option>
                  <option value={'SERVICO'}>Serviço</option>
                  <option value={'PRODUTO'}>Produto</option>
                </select>
              )
              : loading ? <LoadingSpan style={{marginLeft: '0.5rem'}}/> : ""}
              </h2>)} */}
          </div>
          {!loading && !loadingCharts && !loadingReports && !loadingUnitConsumers &&(
            <div className='modal-body py-lg-4 px-lg-10'>
              <div className='divGlobalHeader'>
                <div className='divHeaderPlant' style={{flex: largura > 1052 ? '3.2' : ''}}>
                  <div className='card-body py-0'>
                    <div className='d-flex flex-sm-nowrap mb-0 align-items-center'>
                      
                      <div className='me-7 mb-0 divGlobalImg'>
                        <div 
                          className={`symbol ${largura > 500 ? 'symbol-125px' : 'symbol-100px'} symbol-fixed position-relative divSubImg`} 
                        >
                          <img src={toAbsoluteUrl('/media/imgs/plantComposite.png')} alt='Metornic' />
                          <div 
                            className={
                              `position-absolute translate-middle bottom-0 start-100 mb-6 bg-${
                                data && data.status !== null
                                  ? data.status === 0
                                  ? "success"
                                  : data.status === 1
                                  ? "danger"
                                  : data.status === 2
                                  ? "warning"
                                  : data.status === 7 || data.status === 3
                                  ? "info"
                                  : "secondary"
                                : "secondary"
                              
                              } rounded-circle border border-4 border-white h-20px w-20px`}
                          ></div>

                        </div>
                      </div>

                      <div className='flex-grow-1'>
                        <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                          <div className='d-flex flex-column'>
                            <div className='d-flex align-items-center mb-2'>
                              <a href='#' className='text-gray-800 text-hover-primary fs-1 fw-bolder me-2'>
                                {data && data.name ? data.name : `Usina ${data && data.plantId ? data.plantId : ""}`}
                              </a>
                              <span 
                                className={
                                  `badge badge-light-${
                                    data && data.status !== null
                                      ? data.status === 0
                                      ? "success"
                                      : data.status === 1
                                      ? "danger"
                                      : data.status === 2
                                      ? "warning"
                                      : data.status === 7 || data.status === 3
                                      ? "info"
                                      : "secondary"
                                    : "secondary"
                                  
                                  } ${largura < 500 ? 'fs-7' : 'fs-6'} fw-semibold`}
                              >
                                {
                                  data && data.status !== null
                                    ? data.status === 0
                                    ? "On-line"
                                    : data.status === 1
                                    ? "Off-line"
                                    : data.status === 7 || data.status === 3
                                    ? "Lembrar"
                                    : data.status === 2
                                    ? "Alerta"
                                    : "Desconhecido"
                                  : "Desconhecido"
                                }
                              </span>
                            </div>

                            <div className={`d-flex flex-wrap fw-bold ${largura < 500 ? 'fs-7' : 'fs-5'} mb-0 pe-2`}>
                              <a
                                href='#'
                                className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                              >
                                {/* <KTSVG
                                  path='/media/icons/duotune/communication/com006.svg'
                                  className='svg-icon-4 me-1'
                                /> */}
                                <FaHandshake className='text-muted me-1' style={{fontSize: '1.1rem'}}/>
                                {
                                  data && data.client ? 
                                  data.client.nameResponsible
                                  : <NotImported className={`${largura < 500 ? 'fs-7' : 'fs-5'} text-gray-400 text-hover-primary`}/> 
                                }
                                
                              </a>
                            </div>

                            <div className={`d-flex flex-wrap fw-bold ${largura < 500 ? 'fs-7' : 'fs-5'} mb-0 pe-2`}>
                              <a
                                href='#'
                                className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                              >
                                <KTSVG
                                  path="/media/icons/duotune/maps/map001.svg"
                                  className='svg-icon-4 me-1'
                                />
                                {data && data.address ? data.address : <NotImported className={`${largura < 500 ? 'fs-7' : 'fs-5'} text-gray-400 text-hover-primary`}/>}
                              </a>
                            </div>
                            
                            <div className={`flex-wrap fw-bold ${largura < 500 ? 'fs-7' : 'fs-5'} mb-2 pe-2`} style={{display: 'flex', alignItems: 'center'}}>
                              <a
                                href='#'
                                className='d-flex align-items-center text-gray-400 text-hover-primary me-5'
                              >
                                {/* <KTSVG
                                  path="/media/icons/duotune/maps/map001.svg"
                                  className='svg-icon-4 me-1'
                                /> */}
                                {/* <i className="bi bi-currency-dollar svg-icon-4" style={{marginRight: '0.5rem'}}></i> */}
                                <span style={{marginRight: '0.5rem'}}>R$</span>
                                {data && data.value_implementation ? parseFloat(data.value_implementation)  : 0}
                              </a>
                              {/* {user.currentUser && user.currentUser.companies && user.currentUser.companies.length > 0
                                && user.currentUser.companies[0].planos === "PREMIUM" &&
                                  user.currentUser?.role.slug !== "CLIENTE" &&(
                                  <a
                                    onClick={(event: any) => {
                                      setShowUpdateModal(true)
                                    }}
                                    href='#'
                                    className='btn btn-icon btn-bg-light btn-active-color-primary'
                                    style={{width: '1.7rem', height: '1.7rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                                  >
                                    <KTSVG
                                    path='/media/icons/duotune/art/art005.svg'
                                    className='svg-icon-5'
                                    />
                                  </a>
                              )} */}
                            </div>

                            <div className={`d-flex flex-wrap fw-bold ${largura < 500 ? 'fs-7' : 'fs-5'} mb-0 pe-2`}>
                              <a
                                href='#'
                                className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                              >
                                <KTSVG
                                  path="/media/icons/duotune/coding/cod009.svg"
                                  className='svg-icon-4 me-1'
                                />
                                <div>
                                  {data && data.marks && data.marks.length > 0 ?
                                    data.marks.map((mark) => {
                                      if(mark.link_imagem){
                                        return (
                                          <div 
                                            className='symbol symbol-20px me-1 p-1 bg-light'
                                            data-bs-toggle='tooltip'
                                            title={`${mark.name}`}
                                            style={{cursor: 'pointer'}}
                                          >
                                            <img
                                                src={toAbsoluteUrl(`${mark.link_imagem}`)}
                                                className=''
                                                alt=''
                                              />
                                          </div>
                                        )
                                      }
                                    })
                                    : <NotImported className={`${largura < 500 ? 'fs-7' : 'fs-5'} text-gray-400 text-hover-primary`}/>
                                  }
                                </div> 
                              </a>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='card-body pb-0 divCardBody' style={{flex: largura > 1052 ? '4' : ''}}>
                  
                  <div className='d-flex flex-wrap flex-stack' style={{width: '100%'}}>
                    <div className='d-flex flex-column flex-grow-1'>
                      <div className='d-flex flex-wrap'>
                        <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 d-flex flex-wrap divDateModal' >
                          
                          <div className='divItemDate'>
                            <div className='d-flex divMiniItem'>
                              <div className='fs-5 fw-bolder'>{data && data.createDate ? formatDateInverter(data.createDate) : <NotImported className="fs-5 fw-bolder"/>}</div>
                              <div className='fw-bold fs-8 text-gray-400'>Data de instalação</div>
                            </div>

                            <div className='d-flex divMiniItem'>
                              <div className='fs-5 fw-bolder'>{data && data.capacity ? data.capacity : "0"} KWp</div>
                              <div className='fw-bold fs-8 text-gray-400'>Capacidade</div>
                            </div>

                            {data && data.plano && data.plano === "PREMIUM" &&
                            (<div className='d-flex divMiniItem'>
                              <div className='fs-5 fw-bolder'>~{data && data.economy_total ? data.economy_total : "0"} R$</div>
                              <div className='fw-bold fs-8 text-gray-400'>Economizado (total)</div>
                            </div>)}
                          </div>
                          
                          <div className='divItemDate'>
                            {/* <div className='d-flex divMiniItem'>
                              <div className='fs-5 fw-bolder'>
                                {data.incomeToday ? data.incomeToday + " R$" : "0"}
                              </div>
                              <div className='fw-bold fs-8 text-gray-400'>Rendimento</div>
                            </div> */}

                            <div className='d-flex divMiniItem'>
                              <div className='fs-5 fw-bolder'>{data && data.total_sum ? data.total_sum : "0"} KWh</div>
                              <div className='fw-bold fs-8 text-gray-400'>Energia Gerada (Total)</div>
                            </div>

                            <div className='d-flex divMiniItem'>
                              <div className='fs-5 fw-bolder'>{data && data.energyToday ? data.energyToday : "0"} KWh</div>
                              <div className='fw-bold fs-8 text-gray-400'>Energia Gerada (Hoje)</div>
                            </div>

                            {data && data.plano && data.plano === "PREMIUM" &&
                            (<div className='d-flex divMiniItem'>
                              <div className='fs-5 fw-bolder'>{data && data.feedback_financial ? data.feedback_financial : "0"} %</div>
                              <div className='fw-bold fs-8 text-gray-400'>Retorno Financeiro (Total)</div>
                            </div>)}
                          </div>
                          
                          <div className='divItemDate'>
                            <div className='d-flex divMiniItem'>
                              <div className='fs-5 fw-bolder'>{data && data.monthly_sum ? data.monthly_sum : "0"} KWh</div>
                              <div className='fw-bold fs-8 text-gray-400'>Energia Gerada (Mês)</div>
                            </div>

                            <div className='d-flex divMiniItem'>
                              <div className='fs-5 fw-bolder'>{data && data.consumption ? data.consumption : "0"} KWh</div>
                              <div className='fw-bold fs-8 text-gray-400'>Consumo (Total)</div>
                            </div>
                          </div>

                          <div className='divItemDate divStatusDateRow'>
                            <div className='d-flex align-items-center'>
                              <span className='bullet bullet-dot bg-success me-2' style={{width: '5px', height: '5px'}}></span>
                              <span className='fw-semibold fs-9 text-gray-400 me-1'>Último online:</span>
                              <span className='fs-8 fw-bolder'>
                                {data && data.first_online_today ? formatDateTimeBarra(data.first_online_today) : <NotImported className="fs-8 fw-bolder"/>}
                              </span>
                            </div>

                            <div className='d-flex align-items-center'>
                              <span className='bullet bullet-dot bg-danger me-2' style={{width: '5px', height: '5px'}}></span>
                              <span className='fw-semibold fs-9 text-gray-400 me-1'>Último offline:</span>
                              <span className='fs-8 fw-bolder'>
                                {data && data.last_offline_time ? formatDateTimeBarra(data.last_offline_time) : <NotImported className="fs-8 fw-bolder"/>}
                              </span>
                            </div>

                            <div className='d-flex align-items-center'>
                              <KTSVG path='/media/icons/duotune/arrows/arr029.svg' className='svg-icon-6 svg-icon-primary me-2' />
                              <span className='fw-semibold fs-9 text-gray-400 me-1'>Última atualização:</span>
                              <span className='fs-8 fw-bolder'>
                                {data && data.lastUpdate ? formatDateTimeBarra(data.lastUpdate) : <NotImported className="fs-8 fw-bolder"/>}
                              </span>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='divMenuOpcoes'>
                <div className='card-body divCardBodyMenu'>
                  
                  <div className='d-flex overflow-auto h-55px' style={{marginBottom: '1rem'}}>
                    <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                      <li className='nav-item'>
                        <a
                          className="nav-link active text-active-primary border-active-primary border-hover-primary me-6"
                          data-bs-toggle="tab"
                          href="#details"
                          style={{whiteSpace: 'nowrap'}}
                        >
                          Mais detalhes
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className="nav-link text-active-primary border-active-primary border-hover-primary me-6"
                          data-bs-toggle="tab"
                          href="#relators"
                        >
                          Relatórios
                        </a>
                      </li>
                      {largura < 1200 && (
                        <li className='nav-item'>
                          <a
                            className="nav-link text-active-primary border-active-primary border-hover-primary me-6"
                            data-bs-toggle="tab"
                            href="#grapics"
                          >
                            Gráficos
                          </a>
                        </li>
                      )}
                      <li className='nav-item'>
                        <a
                          className="nav-link text-active-primary border-active-primary border-hover-primary me-6"
                          data-bs-toggle="tab"
                          href="#alarms"
                          style={{display: 'flex', gap: '0.5rem'}}
                        >
                          <span>
                            Alarmes
                          </span>

                          {data && data && data.alarms && data.alarms.length > 0 ? <span className='badge badge-warning'>
                            {data.alarms.length}
                          </span> : <></>}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className="nav-link text-active-primary border-active-primary border-hover-primary me-6"
                          data-bs-toggle="tab"
                          href="#all"
                        >
                          Outros
                        </a>
                      </li>

                      <li className='nav-item'>
                        <a
                          className="nav-link text-active-primary border-active-primary border-hover-primary me-6"
                          data-bs-toggle="tab"
                          href="#tags"
                          style={{whiteSpace: 'nowrap'}}
                        >
                          Tags
                        </a>
                      </li>
                      {data && data.plano && (data.plano === "PREMIUM" || data.plano === "STARTER") &&
                      <li className='nav-item'>
                        <a
                          className="nav-link text-active-primary border-active-primary border-hover-primary me-6"
                          data-bs-toggle="tab"
                          href="#comments"
                        >
                          Comentários
                        </a>
                      </li>}

                      {data && data.plano && (data.plano === "PREMIUM" || data.plano === "STARTER") &&
                      <li className='nav-item'>
                        <a
                          className="nav-link text-active-primary border-active-primary border-hover-primary me-6"
                          data-bs-toggle="tab"
                          href="#anexos"
                        >
                          Anexos
                        </a>
                      </li>}
                    </ul>
                  </div>

                  <div className="tab-content" id="myTabContent5">
                    <div 
                      className="tab-pane fade active show"
                      id="details"
                      role="tabpanel"
                    >
                      <DetailsPlants 
                        data={data}
                        clima={clima}
                      />
                    </div>

                    <div 
                      className="tab-pane fade show divTableReport"
                      id="relators"
                      role="tabpanel"
                    >
                      <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem'}}>
                        <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span style={{whiteSpace: 'nowrap'}}>Tipo de relatório: </span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Descrição do kit instalado na usina'
                          ></i>
                        </label>
                        <select
                          className='form-select form-select-solid'
                          data-kt-select2='true'
                          data-placeholder='Select option'
                          data-allow-clear='true'
                          value={filterTypeRepots}
                          onChange={(e: any) => {
                            setFilterTypeReports(e.target.value)
                          }}
                        >
                          <option value={"DETALHADO"}>DETALHADO</option>
                          <option value={"GERACAO"}>GERAÇÃO</option>
                        </select>
                      </div>

                      {filterTypeRepots === "GERACAO" ? 
                          <TableReportGenerationModalPlant reportsGeneration={reportsGeneration} loading={loadingReports} />
                        :
                          <TableReportModalPlant reports={reports} loading={loadingReports}/>
                      }
                    </div>

                    <div
                      id="all"
                      role="tabpanel"
                      className='tab-pane fade show'
                    >
                      <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 d-flex flex-wrap flex-direction-column' style={{gap: '1rem'}}>
                        <h3 className='card-title d-flex align-items-start flex-column'>
                          <span className='card-label fw-bold fs-5 mb-1'>Unidades Consumidoras</span>
                          <span className='text-muted fw-semibold fs-7'>Todas as unidades consumidoras vinculadas a usina {}</span>
                        </h3>
                        <div className='divTableUnitConsumer'>
                          <TableUnitConsumerModalPlant loading={loadingUnitConsumers} unitConsumers={unitConsumers}/>
                        </div>
                      </div>

                      <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 d-flex flex-wrap flex-direction-column' style={{gap: '1rem'}}>
                        <h3 className='card-title d-flex align-items-start flex-column'>
                          <span className='card-label fw-bold fs-5 mb-1'>Dispositivos</span>
                          <span className='text-muted fw-semibold fs-7'>Todos os inversores vinculados a usina {}</span>
                        </h3>
                        <div className='divTableUnitConsumer'>
                          <TableDevicesModalPlant loading={loading} devices={data && data.devices ? data.devices : undefined}/>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade show"
                      id="alarms"
                      role="tabpanel"
                    >

                      <ItemAlarm alarms={data && data.alarms ? data.alarms : []}/>
                    </div>

                    <div
                      className="tab-pane fade show"
                      id="tags"
                      role="tabpanel"
                    >
                      <TagsPlant data={data ? data : null}/>
                    </div>

                    {largura < 1200 &&(
                      <div 
                        className="tab-pane fade show"
                        id="grapics"
                        role="tabpanel"
                        //style={{background: 'green'}}
                      >
                        <GraphicsModalPlant 
                          myProg={data && data.prognosis ? data.prognosis : null} 
                          charts={data && data.charts ? data.charts : {}} 
                          loading={loadingCharts} 
                          prognostico={data && data.annual_generation_forecast ? data.annual_generation_forecast : null} 
                          plantId={data && data.plantId ? data.plantId : ""}
                          plantData={data}
                        />
                      </div>
                    )
                    }
                    <div
                      className="tab-pane fade show"
                      id="comments"
                      role="tabpanel"
                    >
                      <CommentsPlant
                        data={data ? data : null}
                      />
                    </div>

                    <div
                      className="tab-pane fade show"
                      id="anexos"
                      role="tabpanel"
                    >
                      <ArchivesPlant
                        data={data ? data : null}
                      />
                    </div>
                  </div>
                </div>

                {largura > 1200 && (
                  <GraphicsModalPlant 
                    myProg={data && data.prognosis ? data.prognosis : null} 
                    charts={data && data.charts ? data.charts : null} 
                    loading={loadingCharts} 
                    prognostico={data && data.annual_generation_forecast ? data.annual_generation_forecast : null}
                    plantId={data && data.plantId ? data.plantId : ""}
                    plantData={data}
                  />
                  )}
              </div>
            </div>
          )}
          {
            // eslint-disable-next-line no-mixed-operators
            loading || loadingCharts &&(
              <div className='modal-body py-lg-4 px-lg-10 divLoading' >
                <Loading myClass='spinner-border loading'/>
              </div>
            )
          }
        </div>

        <ModalUpdatePlant
          show={showUpdateModal}
          data={data ? data : {}}
          id={data ? data.id : undefined}
          handleClose={() => {
            setShowUpdateModal(false)
            refresh()
          }}
        />

        <ModalUpdatePrognosisPlant
          show={showUpdatePrognosisModal}
          data={data ? data : {}}
          id={data ? data.id : undefined}
          handleClose={() => {
            setShowUpdatePrognosisModal(false)
            refresh()
          }}
        />
    </Modal>,
    modalsRoot
  )
}

export {ModalPlantComposite}
